import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-fm-footer',
  templateUrl: './fm-footer.component.html',
  styleUrls: ['./fm-footer.component.scss'],
})
export class FmFooterComponent {}
